// API Configuration
const getApiUrl = (): string => {
  const hostname = window.location.hostname;
  
  // Local development - call remote dev API over internet
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return 'https://dev.api.skll.com';
  }
  
  // Deployed on server - use relative paths (nginx will proxy to localhost:3000 backend)
  return '';
};

export const API_URL = getApiUrl();
export const GRAPHQL_URL = API_URL ? `${API_URL}/graphql` : '/graphql';
export const UPLOAD_URL = API_URL ? `${API_URL}/api/upload` : '/api/upload';

